import { useState, useEffect, useContext, useMemo, useRef } from "react";
import {
  Flex,
  Text,
  Box,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Heading,
  Grid,
  Button,
  Tooltip,
  Checkbox,
  useBreakpointValue,
  Center,
  IconButton,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverBody,
  Select,
  Input,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from "@chakra-ui/react";
import { appRequest } from "routes";
import {
  FaEdit,
  FaFileExcel,
  FaFilePdf,
  FaFileUpload,
  FaHistory,
  FaPlus,
} from "react-icons/fa";
import Pagination from "components/common/Pagination/Pagination";
import { AppContext } from "AppProvider/AppContext";
import debounce from "lodash/debounce";
import { Paginationlimit } from "components/common/functions/variable";
import ViewerModal from "App/BsesPoc/components/common/ViewerModal/ViewerModal";
import { CopyIcon, SearchIcon, ChevronDownIcon } from "@chakra-ui/icons";
import MultiDropdown from "components/common/multiDropdown/MultiDropdown";
import Datepicker from "./common/DatePicker";
import AddComentModal from "./common/AddComentModal/AddComentModal";
import { canShowDocuments } from "./common/function";
import { getForeignLabel } from "./common/CommentDrawer/function";
import React from "react";
import { RiDeleteBin5Line } from "react-icons/ri";
import { AiFillEye } from "react-icons/ai";
import CustomDateRangePicker from "./common/CustomDateRangePicker/CustomDateRangePicker";
import { HiOutlineDocumentAdd, HiOutlineRefresh } from "react-icons/hi";
import SearchBox from "components/layouts/MainWindow/Navbar/SearchBox";
import FileViewerModal from "./common/ViewerModal/FileViewerModel";
import TableViewerModel from "./common/TableViewer/TableViewer";
import CurbayViewerModel from "./common/ViewerModal/CurbayViewerModal/CurbayViewerModel";
import {
  MdArrowUpward,
  MdArrowDownward,
  MdEmail,
  MdAssignmentInd,
  MdCancel,
} from "react-icons/md";
import { keyframes } from "@emotion/react";
import TableLoader from "components/common/TableLoader/TableLoader";
import WordDocumentViewer from "./common/WordDocumentViewer/WordDocumentViewer";
import ApprovalHistoryModal from "./common/ApprovalHistoryModal/ApprovalHisoryModal";
import UploadDocumentModal from "./common/UploadDocumentModal/UploadDocumentModal";
import {
  addOneDayToDate,
  DDMMYYYY_FORMAT,
  formatDateTime,
} from "utils/dateUtils/dateUtils";
import DynamicSchemaModel from "./common/ViewerModal/DynamicSchemaModel";
import exportToExcelsss, {
  transformData,
} from "./common/PRYViewer/component/utils/functions";
import MailModal from "./common/PRYViewer/component/MailModal";
import CurbayMedicineCustomModal from "./common/PRYViewer/component/CurbayMedicineCustomModal";
import FieldsModal from "./common/fields/FieldsModal";
import DeleteModal from "./common/Modals/DeleteModal";
import FilesModal from "./common/FilesModal/FilesModal";
import WithDrawalDocModal from "./common/Modals/WithDrawalDocModal";
import AddtionalDocumentModal from "./common/addionalDocumentModal/AddionalDocumentModal";
import DownloadExcelComponent from "./DownloadExcelComponent";
import AssignDocumentModal from "./Approvals/component/AssignDocumentModal";
import { Portal } from "@chakra-ui/react";
import ForeignProcess from "./foreignProcess/ForeignProcess";
import EmergingProcess from "./emergingProcess/EmergingProcess";
import CrmProcess from "./crmProcess/CrmProcess";
import PrProcess from "./PrProcess/PrProcess";
import { extractDocumentNumber } from "utils/functions/function";
import SrProcess from "./SrProcess/srProcess";
import POComponent from "./POComponent/POComponent";

const blinkAnimation = keyframes`
  0% { background-color: transparent; }
  50% { background-color: rgba(255, 165, 0, 0.4); }
  100% { background-color: transparent; }
`;

type Data = {
  _id: string;
  invoiceNo: string;
  dueDate: string;
  submittedOn: string;
  approvedOn: string;
  modifiedOn: string;
  comment?: string;
  status: string;
  file?: any;
  values?: any;
};

export default function DocumentsTable({
  name,
  type,
  activePage,
  isDisabled,
  isManual,
}: {
  name: string;
  type: string;
  activePage: string;
  isDisabled: boolean;
  isManual: boolean;
}): JSX.Element {
  const [appName] = useState<any>(name)
  const [selectedInitiator, setSelectedInitiator] = useState<any>(null)
  const [foreignWorkflows, setForeignWorkflows] = useState<any[]>([])
  const [loadingWorkflows, setLoadingWorkflows] = useState<boolean>(false)
  const [initiatorSearchTerm, setInitiatorSearchTerm] = useState<string>("");

  const filteredInitiators = useMemo(() => {
    return foreignWorkflows.filter((wf: any) =>
      (wf.level1_username || wf.workFlowName || "").toLowerCase().includes(initiatorSearchTerm.toLowerCase())
    );
  }, [foreignWorkflows, initiatorSearchTerm]);
  const [openDeleteModal, setOpenDeleteModal] = useState<any>({
    data: null,
    open: false,
  });

  const [singleDocumentUplaod, setSingleDocumentUplaod] = useState({
    open: false,
    data: null,
    type: "foreign",
    file: null,
  });

  const [withdrawalDoc, setWithdrawalDoc] = useState<any>({
    data: null,
    open: false,
    loading: false,
  });
  const [wordType, setWordType] = useState<any>("view");
  const [openTableModel, setOpenTableModel] = useState<any>({
    type: "file",
    open: false,
    file: null,
  });
  const [openFilesModal, setOpenFilesModel] = useState<any>({
    type: "files_verification",
    open: false,
    file: null,
    data: null,
  });
  const [openSchemaModel, setOpenSchemaModel] = useState({
    open: false,
    type: "schema",
    data: null,
    initialUpload: false,
    file: null,
  });
  const {
    workFlowData,
    setActiveWorkflow,
    activeWorkflow,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    resetDates,
    workflowProcess,
    selectedLevel
  } = useContext(AppContext);

  const [commentModel, setCommentModel] = useState<any>({
    selectedStatus: "approved",
    open: false,
    comment: "",
    isMulti: false,
  });
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const { toastNotify } = useContext(AppContext);
  const [data, setData] = useState<Data[]>([]);
  const [search, setSearch] = useState("");
  const [selectedFile, setSelectedFile] = useState<any>({});
  const [values, setValues] = useState<any>({});
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isOpen, setIsOpen] = useState({
    isOpen: false,
    data: null,
    type: "isFile",
  });
  const [assignDocument, setAssignDocument] = useState({
    open: false,
    data: null,
  });
  const [initialLoad, setInitialLoad] = useState(true);
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("asc");
  const [sortColumn, setSortColumn] = useState<keyof Data | null>(null);
  const [tagType, setTagType] = useState("");
  const [documentType, setDocumentType] = useState(null);
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [level, setLevel] = useState<string | null>(null);
  const [comment, setComment] = useState<string>("");
  const { accountDetails } = useContext(AppContext);
  const [transformedOptions, setTransformedOptions] = useState([]);
  const [tableObject, setTableObject] = useState<any>([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [sortDirection, setSortDirection] = useState<any>({});
  const [approvalData, setApprovalData] = useState([]);
  const [documentID, setDocumentID] = useState<any>(null);
  const [transformedData, setTransformedData] = useState<any[]>([]);
  const [fileData, setFileData] = useState<any>(null);
  const [sendMail, setSendMail] = useState<any>(false);
  const [fieldName, setFieldName] = useState<string[]>([]);
  const [finalResults, setFinalResults] = useState<any>([]);
  const fileInputRef = useRef<any>(null);
  const zipFileInputRef = useRef<any>(null);
  const isBreakpoint = useBreakpointValue({ base: true, lg: false });
  const [isMailOpen, setIsMailOpen] = useState<any>({
    open: false,
    data: null,
  });
  const [searchFilters, setSearchFilters] = useState<any[]>([]);
  const [selectedOptions, setSelectedOptions] = useState<any>({});
  const [addtionalDocuments, setAddtionalDocuments] = useState({
    open: false,
    data: [],
  });

  const handleCloseModal = () => {
    setSelectedFile({});
    setValues({});
    setIsOpen({ isOpen: false, data: null, type: "isFile" });
    setSelectedRows([]);
    setCommentModel({
      selectedStatus: "approved",
      open: false,
      comment: "",
      isMulti: false,
    });
    setWordType("view");
  };

  const getComment = (data: any) => {
    if (data && Array.isArray(data)) {
      if (data.length) {
        let ddt: any = data.filter(
          (item: any) => item.level === accountDetails.level,
        );
        if (ddt.length) {
          return ddt[ddt.length - 1].comment;
        } else {
          return data[data.length - 1].comment;
        }
      }
      return "-";
    } else {
      return "-";
    }
  };

  const handleOpenMail = (values: any) => {
    let transformed: any = [];
    if (Array.isArray(values)) {
      transformed = values[values?.length - 1]?.values;
    } else {
      if (Array.isArray(values?.values?.results)) {
        if (Array.isArray(values?.values?.results)) {
          let data = transformData(values?.values?.results);
          const groupedData = data.reduce(
            (acc: any[], { fieldName, rows, pageIndex }: any) => {
              if (!acc[pageIndex]) {
                acc[pageIndex] = { pageIndex, fields: {} };
              }
              acc[pageIndex].fields[fieldName] = rows.map((row: any) => {
                const rowData: any = {};
                for (const key in row) {
                  if (key !== "id") {
                    rowData[key] = row[key];
                  }
                }
                return rowData;
              });
              return acc;
            },
            [],
          );
          transformed = groupedData;
          setTransformedData(groupedData);
        }
      }
      transformed = values;
    }
    setTransformedData(transformed);
    setIsMailOpen({ open: true });
  };

  const handleCloseMail = () => {
    setIsMailOpen({ open: false, data: null });
  };

  const getDocumentType = (data: any) => {
    if (
      data.length &&
      name === "Pending Approval" &&
      accountDetails.level !== "level-1"
    ) {
      if (data.length) {
        let level: any = null;
        if (accountDetails.level === "level-2") {
          level = "level-1";
        }
        if (accountDetails.level === "level-3") {
          level = "level-2";
        }
        const dd: any = data.filter((item: any) => item.level === level);
        if (dd.length) {
          return dd[0].status;
        }
      }
      return null;
    } else {
      return null;
    }
  };

  const handleOpenModal = ({
    file,
    value,
    id,
    level,
    approvalData,
    documentId,
    tagType,
    item,
    type,
    modalType,
  }: {
    file: any;
    value: any;
    id: any;
    level: any;
    approvalData: any;
    documentId: any;
    tagType: string;
    item: any;
    type: string;
    modalType: string;
  }) => {
    if (file) {
      setSelectedFile(file);
    }
    setDocumentID(documentId);
    setApprovalData(approvalData);
    if (workFlowData?.fileViewer?.approvalModalOption === "schema") {
      setValues(value);
      setSelectedId(id);
      setLevel(level);
      setComment(getComment(approvalData));
      setDocumentType(getDocumentType(approvalData));
      setSelectedRows((prevVal) => [...prevVal, item]);
      if (type === "pdfApproval") {
        setIsOpen({ isOpen: true, data: item, type: type });
        if (file) {
          setSelectedFile(file);
        }
        setApprovalData(approvalData);
        setDocumentID(documentId);
      } else if (item?.processName === "foreign") {
        setSelectedFile(file);
        setDocumentID(documentId);
        setApprovalData(approvalData);
        setSingleDocumentUplaod({
          open: true,
          type: "foreign",
          data: item,
          file: file,
        });
      } else if (item?.processName === "emerging") {
        setSelectedFile(file);
        setDocumentID(documentId);
        setApprovalData(approvalData);
        setSingleDocumentUplaod({
          open: true,
          type: "emerging",
          data: item,
          file: file,
        });
      } else if (item?.processName === "crm") {
        setSelectedFile(file);
        setDocumentID(documentId);
        setApprovalData(approvalData);
        setSingleDocumentUplaod({
          open: true,
          type: "crm",
          data: item,
          file: file,
        });
      } else if (item?.processName === "pr") {
        if (selectedFile) {
          setSelectedFile(file);
        }
        setDocumentID(documentId);
        setApprovalData(approvalData);
        setSingleDocumentUplaod({
          open: true,
          type: "pr",
          data: item,
          file: file,
        });
      }
      else if (item?.processName === "sr") {
        if (selectedFile) {
          setSelectedFile(file);
        }
        setDocumentID(documentId);
        setApprovalData(approvalData);
        setSingleDocumentUplaod({
          open: true,
          type: "sr",
          data: item,
          file: file,
        });
      }
      else if (item?.processType === "Po" || item?.processType === "po") {
        if (selectedFile) {
          setSelectedFile(file);
        }
        setDocumentID(documentId);
        setApprovalData(approvalData);
        setSingleDocumentUplaod({
          open: true,
          type: "po",
          data: item,
          file: file,
        });
      }
      else if (type !== "pdfApproval") {
        setOpenSchemaModel({
          open: true,
          data: item,
          type: "schema",
          initialUpload: false,
          file: null,
        });
      }
    } else if (file && !workFlowData?.fileViewer?.approvalModalOption.isWord) {
      setSelectedFile(file);
      setValues(value);
      setSelectedId(id);
      setLevel(level);
      setComment(getComment(approvalData));
      setApprovalData(approvalData);
      setDocumentType(getDocumentType(approvalData));
      setTagType(tagType);
      setSelectedRows((prevVal) => [...prevVal, item]);
      setIsOpen({ isOpen: true, data: item, type: type });
      setDocumentID(documentId);
    } else {
      if (
        !file &&
        (workFlowData?.fileViewer.approvalModalOption === "isWord" ||
          workFlowData?.fileViewer.approvalModalOption === "files_verification")
      ) {
        setSelectedFile(file);
        setValues(value);
        setSelectedId(id);
        setLevel(level);
        setComment(getComment(approvalData));
        setDocumentType(getDocumentType(approvalData));
        setTagType(tagType);
        setSelectedRows((prevVal) => [...prevVal, item]);
        if (workFlowData?.fileViewer.approvalModalOption === "isWord") {
          setIsOpen({ isOpen: true, data: item, type: type });
        }
        if (
          workFlowData?.fileViewer.approvalModalOption === "files_verification"
        ) {
          setOpenFilesModel({
            open: true,
            data: item,
            type: workFlowData?.fileViewer.approvalModalOption,
          });
        }
        setApprovalData(approvalData);
        setDocumentID(documentId);
      } else {
        toastNotify({
          title: "No file",
          message: "Something went wrong",
          type: "error",
        });
      }
    }
  };

  const downloadExcel = async (values: any, action: any) => {
    let transformed: any = [];
    let downloadValues = [];
    if (Array.isArray(values)) {
      transformed = values[values?.length - 1]?.values;
    } else {
      if (Array.isArray(values?.values?.results)) {
        let data = transformData(values?.values?.results);
        const groupedData = data.reduce(
          (acc: any[], { fieldName, rows, pageIndex }: any) => {
            if (!acc[pageIndex]) {
              acc[pageIndex] = { pageIndex, fields: {} };
            }
            acc[pageIndex].fields[fieldName] = rows.map((row: any) => {
              const rowData: any = {};
              for (const key in row) {
                if (key !== "id") {
                  rowData[key] = row[key];
                }
              }
              return rowData;
            });
            return acc;
          },
          [],
        );
        transformed = groupedData;
        setTransformedData(groupedData);
      }
      downloadValues = values;
    }
    setTransformedData(transformed);
    if (workFlowData?.fileViewer?.approvalModalOption === "mdm") {
      exportToExcelsss(transformed, true);
    }
  };

  const handleFetchSapDocNumber = async (item: any) => {
    try {
      const payload = {
        documentId: item.documentId || item._id,
        processType: item.processType || item.poExtractionType,
        processName: item.processName || workFlowData?.processName,
        forUtr:true
      };
      const response: any = await appRequest("document", "getSapDocNumber", payload);
      if (response && response.status === "success" && response.data && response.data.status === "success") {
        toastNotify({
          title: "Success",
          message: response?.data?.remarks || response?.data?.message,
          type: "success",
        });
        handleGet();
      } else {
        throw new Error(response?.data?.message || response?.data?.remarks || "Failed to fetch SAP Document Number");
      }
    } catch (error: any) {
      toastNotify({
        title: "Error",
        message: error?.message || "Failed to fetch SAP Document Number",
        type: "error",
      });
    }
  };

  const [isUploadOpen, setIsUploadOpen] = useState<{ open: boolean; id: any }>({
    open: false,
    id: null,
  });
  const [modalType, setModalType] = useState<string>("");

  const handleOpenUploadModal = (type: string, id?: any) => {
    setOpenSchemaModel({
      open: true,
      data: null,
      type: "schema",
      initialUpload: true,
      file: null,
    });
    return;
    if (id !== null) {
      setIsUploadOpen({ open: true, id: id });
    } else {
      setIsUploadOpen({ open: true, id: null });
    }
    setModalType(type);
  };

  const handleCloseUploadModal = () => {
    setIsUploadOpen({ open: false, id: null });
  };

  const actionButton =
    tableObject?.action?.view ||
    tableObject?.action?.edit ||
    tableObject?.action?.delete;

  const handleGet = async (
    currentP?: number,
    valu?: any,
    reset?: any,
    columnSortByKey?: string,
    columnSortMode?: number,
  ) => {
    if(!workFlowData?.processName) return;
    try {
      let firstActiveItem: any = null;
      if (workFlowData && workFlowData?.table) {
        const activeItems = workFlowData.table.filter(
          (item: any) => item.isActive === true,
        );
        firstActiveItem = activeItems.length > 0 ? activeItems[0] : {};
      }
      if (!loading) setLoading(true);
      let value = search;
      let status = type;
      let limit = firstActiveItem?.isPaginate?.isActive
        ? parseInt(firstActiveItem?.isPaginate?.paginationLimit)
        : Paginationlimit;
      let page = currentP ? currentP : currentPage;

      let query: any = {
        value,
        limit,
        status,
        page,
        level: selectedLevel || accountDetails.level,
        _id: accountDetails.user,
        company: accountDetails.company?._id || accountDetails.company,
      };

      if (
        workFlowData?.searchFilter?.key &&
        workFlowData?.searchFilter?.isActive &&
        value?.trim()
      ) {
        query = { ...query, searchField: workFlowData?.searchFilter?.key };
      }

      // Using global startDate & endDate from context
      if (workFlowData.dateFilter?.rangeActive) {
        query = {
          ...query,
          dateFrom: startDate,
          dateTo: addOneDayToDate(endDate),
        };
      }

      if (reset) {
        resetDates(); // Reset global dates
      }

      if (columnSortByKey && columnSortMode) {
        query = {
          ...query,
          sort: columnSortMode,
          sortByKey: columnSortByKey,
        };
      } else {
        if (workFlowData?.sortBy && workFlowData?.sortBy?.length) {
          const sorts = workFlowData.sortBy.filter(
            (item: any) => item.isActive === true,
          );
          if (sorts?.length) {
            query = {
              ...query,
              sort: sorts[0].mode,
              sortByKey: sorts[0].key,
            };
          }
        }
      }

      if (
        workFlowData.dateFilter?.filterKey &&
        workFlowData.dateFilter?.filterKey?.length
      ) {
        query = { ...query, dateFilterKey: workFlowData.dateFilter?.filterKey };
      }

      if (activeWorkflow !== accountDetails?.defaultWorkflow) {
        query = { ...query, activeWorkflow: activeWorkflow };
      }

      if (type === "manual") {
        query["manual"] = true;
      }

      const searchFilters: any = [];
      for (const key in selectedOptions) {
        if (selectedOptions[key].length > 0) {
          selectedOptions[key].forEach((item: any) => {
            const filterObject: any = {};
            filterObject[key] = item.value;
            searchFilters.push(filterObject);
          });
        } else {
          const filterObject: any = {};
          filterObject[key] = selectedOptions[key].value;
          searchFilters.push(filterObject);
        }
      }

      if (!reset) {
        if (searchFilters.length) {
          query = { ...query, searchFilters: searchFilters };
        }
      }

      // getForeignAdminRejected
      const response: any = await appRequest("document", (workFlowData?.processName === "foreign" && status === "rejected" && accountDetails?.level === "admin") ? "getForeignAdminRejected" : status === "all" ? "getAllDocuments" : "get", {
        ...query,
        workflowId: workFlowData?._id,
        processName: workFlowData?.processName,
        processType: workFlowData?.processType,
        selectInitiator: selectedInitiator
      });

      if (response) {
        if (Array.isArray(response?.data)) {
          setData(response?.data);
          setTotalPages(response?.totalPages);
        } else {
          setData([]);
        }
      } else {
        toastNotify({
          title: `Error getting the Data`,
          message: response.message || "Something went wrong",
          type: "error",
        });
      }
    } catch (error: any) {
      toastNotify({
        title: `Error getting the Data`,
        message: error.message || "Something went wrong",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleExcelImport = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async (event) => {
      const base64 = event.target?.result as string;
      try {
        setLoading(true);
        const res: any = await appRequest("document", "crmBulkImport", { excelData: base64 });
        if (res.status === "success") {
          const { success, skippedCount, errorExcel } = res.data;

          if (errorExcel) {
            const link = document.createElement("a");
            link.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${errorExcel}`;
            link.download = `crm_import_errors_${Date.now()}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }

          toastNotify({
            title: skippedCount > 0 ? "Import Partial Success" : "Import Success",
            message: `Invoices Created: ${success?.length || 0}. Invoices Skipped: ${skippedCount || 0}.${errorExcel ? " Error report downloaded." : ""}`,
            type: skippedCount > 0 ? "warning" : "success"
          });
          handleGet(); // Refresh the table
        } else {
          toastNotify({ title: "Import Error", message: res.message || "Failed to process Excel", type: "error" });
        }
      } catch (err: any) {
        toastNotify({ title: "Error", message: err.message || "Something went wrong during import", type: "error" });
      } finally {
        setLoading(false);
        if (fileInputRef.current) fileInputRef.current.value = ""; // Reset input
      }
    };
    reader.readAsDataURL(file);
  };

  const handleZipImport = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Frontend Validation
    if (!file.name.toLowerCase().endsWith(".zip")) {
      toastNotify({
        title: "Invalid File",
        message: "Please select a standard ZIP file. RAR and other formats are not supported.",
        type: "error"
      });
      if (zipFileInputRef.current) zipFileInputRef.current.value = "";
      return;
    }

    try {
      setLoading(true);
      const chunkSize = 2 * 1024 * 1024; // 2MB
      const totalChunks = Math.ceil(file.size / chunkSize);
      const uploadId = `zip_${Date.now()}_${Math.random().toString(36).substring(7)}`;

      for (let i = 0; i < totalChunks; i++) {
        const start = i * chunkSize;
        const end = Math.min(start + chunkSize, file.size);
        const chunk = file.slice(start, end);

        // Convert chunk to base64
        const chunkBase64 = await new Promise<string>((resolve) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result as string);
          reader.readAsDataURL(chunk);
        });

        const res: any = await appRequest("document", "crmBulkZipImportChunked", {
          uploadId,
          chunkIndex: i,
          totalChunks,
          chunkData: chunkBase64,
          filename: file.name
        });

        if (res.status !== "success") {
          throw new Error(res.message || `Failed to upload chunk ${i + 1}`);
        }

        if (i === totalChunks - 1) {
          // Last chunk processed
          toastNotify({
            title: "ZIP Import Success",
            message: res.message || "ZIP processed successfully.",
            type: "success"
          });
          if (res.data?.failed?.length > 0) {
            toastNotify({
              title: "Some files failed",
              message: `Failed: ${res.data.failed.join(", ")}`,
              type: "warning"
            });
          }
          handleGet();
        }
      }
    } catch (err: any) {
      toastNotify({ title: "Error", message: err.message || "Something went wrong during ZIP import", type: "error" });
    } finally {
      setLoading(false);
      if (zipFileInputRef.current) zipFileInputRef.current.value = "";
    }
  };

  const deleteDocuments = async () => {
    try {
      setDeleteLoading(true);
      const response: any = await appRequest("document", "delete", {
        documentId: openDeleteModal?.data?.documentId,
      });
      if (response) {
        handleGet();
        toastNotify({
          title: `Document has been deleted`,
          message: response.message || "Something went wrong",
          type: "success",
        });
        setOpenDeleteModal({ data: null, open: false });
      } else {
        toastNotify({
          title: `Failed to delete document`,
          message: response.message || "Something went wrong",
          type: "error",
        });
      }
    } catch (error: any) {
      toastNotify({
        title: `Failed to delete document`,
        message: error.message || "Something went wrong",
        type: "error",
      });
    } finally {
      setDeleteLoading(false);
    }
  };

  const withDrawalDocuments = async () => {
    try {
      setWithdrawalDoc({ ...withdrawalDoc, loading: true });
      const response: any = await appRequest("document", "withdrawal", {
        documentId: withdrawalDoc?.data?.documentId,
      });
      if (response) {
        handleGet();
        toastNotify({
          title: `Document has been WithDrawal`,
          message: response.message || "Something went wrong",
          type: "success",
        });
        setWithdrawalDoc({ data: null, open: false, loading: false });
      } else {
        toastNotify({
          title: `Failed to delete document`,
          message: response.message || "Something went wrong",
          type: "error",
        });
      }
    } catch (error: any) {
      setWithdrawalDoc({ ...withdrawalDoc, loading: false });
      toastNotify({
        title: `Failed to delete document`,
        message: error.message || "Something went wrong",
        type: "error",
      });
    } finally {
    }
  };

  const handleSort = (column: keyof Data, direction: number) => {
    setSortDirection((prevState: any) => ({
      ...prevState,
      [column]: prevState[column] === "asc" ? "desc" : "asc",
    }));
    Object.keys(sortDirection).forEach((columnKey) => {
      if (columnKey !== column) {
        setSortDirection((prevState: any) => ({
          ...prevState,
          [columnKey]: undefined,
        }));
      }
    });
    handleGet(undefined, undefined, undefined, column, direction);
  };

  const sortedData = useMemo(() => {
    if (sortColumn) {
      const sortedArray = [...data].sort((a, b) => {
        const valueA = a[sortColumn] ?? "";
        const valueB = b[sortColumn] ?? "";
        if (valueA < valueB) return sortOrder === "asc" ? -1 : 1;
        if (valueA > valueB) return sortOrder === "asc" ? 1 : -1;
        return 0;
      });
      return sortedArray;
    }
    return data;
  }, [data, sortColumn, sortOrder]);

  useEffect(() => {
    setLoading(true);
    if (initialLoad) {
      handleGet(currentPage);
      setInitialLoad(false);
    } else {
      const debounceSearch = debounce((value) => {
        handleGet(currentPage, value);
      }, 1000);
      debounceSearch(search);
      return () => {
        debounceSearch.cancel();
      };
    }
  }, [
    search,
    currentPage,
    activePage,
    workFlowData,
    activeWorkflow,
    startDate,
    endDate,
    selectedLevel,
    selectedInitiator
  ]);

  useEffect(() => {
    const fetchForeignWorkflows = async () => {
      const cached = sessionStorage.getItem("foreignWorkFlowsData");
      if (cached) {
        setForeignWorkflows(JSON.parse(cached));
        return;
      }
      try {
        setLoadingWorkflows(true);
        const response: any = await appRequest("document", "getForeignWorkFlows", {});
        if (response && response.status === "success") {
          setForeignWorkflows(response.data);
          sessionStorage.setItem("foreignWorkFlowsData", JSON.stringify(response.data));
        }
      } catch (error) {
        console.error("Error fetching foreign workflows:", error);
      } finally {
        setLoadingWorkflows(false);
      }
    };

    if (workFlowData?.processName === "foreign") {
      fetchForeignWorkflows();
    } else {
      setForeignWorkflows([]);
      setSelectedInitiator(null);
    }
  }, [workFlowData?.processName]);

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedLevel]);

  const getFile = async (file: any) => {
    try {
      if (file?._id) {
        const response: any = await appRequest("filesystem", "get", {
          id: file._id,
        });
        if (response) {
          if (response?.error) {
          } else {
            let buffer =
              typeof response === "string" ? JSON.parse(response) : response;
            buffer = new Uint8Array(buffer);
            const fileURL = URL.createObjectURL(
              new Blob([buffer], { type: file.metadata.contentType }),
            );
            return fileURL;
          }
        }
      }
    } catch (error: any) {
      toastNotify({
        title: "Error",
        message: error.message,
        type: "error",
      });
    }
  };

  const handlePageChange = (page: any) => {
    setCurrentPage(page.selected + 1);
  };

  const downloadPDF = async (file: any) => {
    const fileUrl = await getFile(file);
    if (fileUrl) {
      const link = document.createElement("a");
      link.href = fileUrl;
      link.style.display = "none";
      link.download = file.filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleSelectedBoxChange = (item: any) => {
    const isSelected = selectedRows.some(
      (selectedItem) => selectedItem._id === item._id,
    );
    setSelectedRows((prevSelectedRows) =>
      isSelected
        ? prevSelectedRows.filter(
          (selectedItem) => selectedItem._id !== item._id,
        )
        : [...prevSelectedRows, item],
    );
  };

  const getStatus = (data: any) => {
    if (Array.isArray(data) && data?.length) {
      return data[data.length - 1].status;
    } else {
      return "-";
    }
  };

  function getApprovalStatus(history: any) {
    let previousFileID: any = null;
    const isRejected = history.some((item: any, index: any) => {
      const fileIDChanged = index > 0 && item.fileId !== previousFileID;
      previousFileID = item.fileId;
      return item.status === "rejected" || fileIDChanged;
    });
    return isRejected ? "rejected" : "approved";
  }

  useEffect(() => {
    if (workFlowData && workFlowData.filters) {
      let filterWorkflowFilter = workFlowData?.filters.filter(
        (item: any) => item.isActive === true,
      );
      const options = filterWorkflowFilter.map((filter: any) => ({
        label: filter.label,
        placeholder: filter.placeholder,
        isMultiSelect: filter.isMultiSelect,
        key: filter.key,
        options: filter.filters
          .filter((nestedFilter: any) => nestedFilter.isActive)
          .map((nestedFilter: any) => ({
            _id: nestedFilter.key,
            value: nestedFilter.key,
            label: nestedFilter.label,
          })),
      }));
      setTransformedOptions(options);
    }
  }, [workFlowData]);

  useEffect(() => {
    if (workFlowData && workFlowData?.table) {
      const activeItems = workFlowData.table.filter(
        (item: any) => item.isActive === true,
      );
      const firstActiveItem = activeItems.length > 0 ? activeItems[0] : {};
      setTableObject(firstActiveItem);
    }
  }, [workFlowData?.table]);

  const getPendingUser = (item: any) => {
    try {
      const history = item?.approval || [];
      const workflow = item?.workflow?.[0];
      const workflowValues = workflow?.values?.[0] || {};
      const approvalsConfig = workflowValues.approvals || [];
      const maxLevelCount = workflowValues.levels;
      const maxLevel = maxLevelCount ? `level-${maxLevelCount}` : null;

     const safeUsername = (user?: {
  username?: string;
  designation?: string;
  name?: string;
}) => {
  if (user?.name || user?.username) {
    if((workflowProcess?.processName === "sr" || workflowProcess?.processName === "pr") && workflowProcess?.processType === "NonPo"){
       if(item.approval?.length > 0 && item.approval[item.approval.length - 1].level === "level-4" && item.approval[item.approval.length - 1].status === "rejected"){
        return item.approval.find((it : any) => it.level === "level-3" && it.status === "approved")?.name || String(user?.name).trim()
       }
    }
    if(String(user?.name || "").trim()){
      return String(user?.name)
    }
  }

  if (String(user?.username || "").trim()) {
    return String(user?.username)
      .split("@")[0]
      .replace(/\./g, " ") // replace all dots with spaces
      .replace(/\s+/g, " ") // normalize multiple spaces
      .trim();
  }

  if (user?.designation) {
    return String(user.designation).trim();
  }

  return "Unknown";
};

      const getForeignLabelInner = (level: string) => {
        switch (level) {
          case "level-1": return "Initiator";
          case "level-2": return "Fi User";
          case "level-3": return "GST User";
          case "level-4": return "TDS User";
          case "level-5": return "Approver 1";
          case "level-6": return "Approver 2";
          case "level-7": return "Approver 3";
          default: return level;
        }
      };

      if (!Array.isArray(approvalsConfig)) return "-";

      if (history.length === 0) {
        const firstAppv = approvalsConfig.find((a: any) => a?.level === "level-1") || approvalsConfig.find((a: any) => a?.isActive);
        if (firstAppv) {
          let text = workFlowData?.processName === "foreign"
            ? `${getForeignLabelInner(firstAppv.level || "")} (${safeUsername(firstAppv)})`
            : safeUsername(firstAppv);
          return text;
        }
        return "Next";
      }

      const lastEntry = history[history.length - 1];

      if (lastEntry?.status === "approved" && lastEntry?.level === maxLevel) {
        return "Posted";
      }

      let nextLevel: string | null = null;
      if (lastEntry?.status === "approved") {
        const curr = parseInt((lastEntry?.level || "").split("-")[1] || "0");
        nextLevel = `level-${curr + 1}`;
      } else if (lastEntry?.status === "rejected") {
        const curr = parseInt((lastEntry?.level || "").split("-")[1] || "1");
        nextLevel = `level-${Math.max(1, curr - 1)}`;
      }

      let nextUser = null;
      if (nextLevel && Array.isArray(approvalsConfig)) {
        nextUser = approvalsConfig.find((a: any) => a?.level === nextLevel) || null;
      }

      if (!nextUser && !nextLevel) {
        return "-";
      }

      let name = "";
      if (workFlowData?.processName === "foreign") {
        name = `${getForeignLabelInner(nextLevel || "")} (${nextUser ? safeUsername(nextUser) : "Unknown"})`;
      } else {
        name = nextUser ? safeUsername(nextUser) : nextLevel || "Next";
        if (((workflowProcess.processName === "pr" || workflowProcess.processName === "sr") && item?.approval?.length === 2) || (appName === "Approved" && (accountDetails?.level === "level-2") && (workflowProcess?.processName === "pr" || workflowProcess?.processName === "sr")) || (appName === "Pending Approval" && (accountDetails?.level === "level-3") && (workflowProcess?.processName === "pr" || workflowProcess?.processName === "sr"))) {
          name = "FI User"
        }
      }

      if (typeof name === "string" && name.includes("@")) {
        name = name.split("@")[0].split(".").map((n: any) => n.charAt(0).toUpperCase() + n.slice(1)).join(" ");
      }
      return name;
    } catch (error) {
      console.error("Error in getPendingUser", error);
      return "-";
    }
  };

  const generateHeaders = () => {
    return (
      <>
        <Th minW={150}>{workFlowData?.processName === "foreign" ? "Creator Name" : "Flow Name"}</Th>
        {workFlowData?.processName === "foreign" && <Th minW={150}>{workFlowData?.processName === "foreign" ? "Region" : "Flow Name"}</Th>}
        <Th minW={140}>Pending At</Th>
        {tableObject?.columnName?.map((column: any, index: any) => {
          const sortingIcon =
            sortDirection[column.key] === "asc" ? (
              <MdArrowUpward />
            ) : (
              <MdArrowDownward />
            );
          const isHovered = hoveredIndex === index;
          if (!column.isActive) return null;
          if(column.key==="created_At"){
            return null
          }
          if(name === "Pending Approval" && column.key==="sapDocumentNumber"){
            return null
          }
          if (column.key === "comments") {
            return null
          }
          if (column.key === "Status" && (workflowProcess?.processType === "NonPo" || workflowProcess?.processType === "nonpo")) {
            return null
          }
          return (
            <Th
              key={index}
              cursor={column.sortActive ? "pointer" : undefined}
              onClick={() => {
                if (column.sortActive) {
                  const direction =
                    sortDirection[column.key] === "asc" ? -1 : 1;
                  handleSort(column.key, direction);
                }
              }}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              textAlign={column.labelCenter === true ? "center" : "left"}
            >
              <Flex alignItems="center" gap={3}>
                <span
                  style={{
                    whiteSpace:
                      column.labelNoWrap === true ? "nowrap" : "unset",
                    textTransform: tableObject?.columnNameUpperCase
                      ? undefined
                      : "none",
                  }}
                >
                  {column.label?.split("_")?.join(" ")}
                </span>{" "}
                {column.sortActive && (
                  <Text
                    color="white"
                    fontSize=".7rem"
                    style={{ visibility: isHovered ? "visible" : "hidden" }}
                    wordBreak="normal"
                  >
                    {sortingIcon}
                  </Text>
                )}
              </Flex>
            </Th>
          );
        })}
        {actionButton && (
          <Th>
            <Text></Text>
          </Th>
        )}
        {/* Actions moved to the right sticky column */}
      </>
    );
  };

  const showComment = (item: any) => {
    if (!Array.isArray(item?.approval) || !item.approval.length) {
      return <Text>-</Text>;
    }

    // Latest comment first
    const comments = item.approval
      .slice()
      .reverse()
      .map((st: any, index: number) => {
        let username = st?.user?.username?.split("@")[0];

        if (username) {
          username = username
            .split(".")
            .map((part: string) => part.charAt(0).toUpperCase() + part.slice(1))
            .join(" ");
        } else {
          username = st?.designation || "Unknown";
        }

        let level = "";
        if (st.level === "admin") {
          level = "Admin";
        } else if (st.user?.level?.includes("level-")) {
          level = `L-${st.user.level.split("-")[1]}`;
        }

        return (
          <Box
            key={index}
            py={2}
            borderBottom="1px solid"
            borderColor="gray.100"
          >
            {st.comment && (
              <Text fontSize="sm" lineHeight="1.4">
                <Text as="span" fontWeight="semibold" color="blue.600">
                  {level} · {username}
                </Text>
                {": "}
                {st.comment}
              </Text>
            )}
          </Box>
        );
      });

    const latestComment =
      item.approval[item.approval.length - 1]?.comment || "-";

    return (
      <Popover
        placement="top-start"
        trigger="hover"
        openDelay={200}
        closeDelay={100}
        isLazy
      >
        <PopoverTrigger>
          <Text
            isTruncated
            maxW="8rem"
            cursor="pointer"
            fontSize="sm"
            color="gray.700"
            _hover={{ color: "blue.600", textDecoration: "underline" }}
          >
            {latestComment}
          </Text>
        </PopoverTrigger>

        {/* 🔥 REQUIRED FIX FOR TABLE */}
        <Portal>
          <PopoverContent maxW="22rem" zIndex={9999} boxShadow="lg">
            <PopoverArrow />
            <PopoverBody maxH="220px" overflowY="auto" px={3} py={2}>
              {comments.length ? comments : <Text>No Comment</Text>}
            </PopoverBody>
          </PopoverContent>
        </Portal>
      </Popover>
    );
  };

  const getTextValue = (item: any, key: any) => {
    if (!item || typeof item !== "object") {
      return "";
    }
    const value = item.originalValues?.[key] || item[key];
    if (typeof value === "string") {
      return value;
    }

    if (value?.value) {
      return value?.value
    }

    return value !== undefined ? JSON.stringify(value) : "";
  };

  const getUtilityDocument = (item: any) => {
    try {
      if (workFlowData?.processName === "domestic") {
        let dt = item.values[item.values?.length - 1].values?.financialForm
        return dt?.forwardDocument || false
      }
      return false;
    }
    catch (e) {
      return false;
    }
  };



  const generateRows = (item: any) => {
    let pendingUser = getPendingUser(item);
    return (
      <React.Fragment key={item._id}>
        <Td key="workFlowName" minW={220}>
          <Tooltip
            hasArrow
            textAlign="center"
            label={
              item.workflow?.length ? item.workflow[0]?.workFlowName : "--"
            }
          >
            <Text noOfLines={1} cursor="pointer">
              {workFlowData?.processName === "foreign" ? item.approval?.length > 0 ? item.approval[0].name : "--" : item.workflow?.length
                ? item.workflow[0]?.flowName || item.workflow[0]?.workFlowName
                : "--"}
            </Text>
          </Tooltip>
        </Td>
        {workflowProcess?.processName === "foreign" && <Td key="regions" minW={220}>
          <Tooltip
            hasArrow
            textAlign="center"
            label={
              item?.originalValues?.region?.label
            }
          >
            <Text noOfLines={1} cursor="pointer">
              {
                workFlowData?.processName === "foreign" && item.workflow?.length
                  ? (
                    item.workflow?.[0]?.flowName ||
                    item.workflow?.[0]?.workFlowName ||
                    ""
                  ).split("-").slice(-1)[0]?.trim() || "--"
                  : "--"
              }
            </Text>
          </Tooltip>
        </Td>}
        <Td
          animation={pendingUser === "FI User" && (workflowProcess?.processName === "pr" || workflowProcess?.processName === "sr") ? `${blinkAnimation} 1.5s infinite ease-in-out` : undefined}
          bg={pendingUser === "FI User" && (workflowProcess?.processName === "pr" || workflowProcess?.processName === "sr") ? "orange.50" : undefined}
          onClick={async(e) => {
          if (pendingUser === "FI User" && (workflowProcess?.processName === "pr" || workflowProcess?.processName === "sr")) {
            e.stopPropagation();
            try {
  const dt: any = await appRequest(
    "prFiUserWithPlantCode",
    "getPrFiUserByPlantCode",
    { plantCode: item.plantCode }
  );

  if (dt?.status === "success" && dt?.data?.username) {
    const { username, profileId, name } = dt.data;

    alert(
      `Document Pending at FI\n\n` +
      `👤 Name: ${name}\n` +
      `🆔 Profile ID: ${profileId}\n` +
      `📧 Email: ${username}`
    );
  } else {
    alert(dt?.message || "Something went wrong");
  }
} catch (err) {
  alert("Failed to load user details");
}
          }
        }}
          key="pendingAt" minW={160} width={160}>
          <Flex align="center" gap={2}>
            <Tooltip hasArrow label={pendingUser === "FI User" && (workflowProcess?.processName === "pr" || workflowProcess?.processName === "sr") ? "Click to view FI User details" : pendingUser} placement="top">
              <Box cursor="pointer">
                <Text
                  isTruncated
                  w="150px"
                  fontWeight={pendingUser === "FI User" && (workflowProcess?.processName === "pr" || workflowProcess?.processName === "sr") ? "bold" : "normal"}
                  color={pendingUser === "FI User" && (workflowProcess?.processName === "pr" || workflowProcess?.processName === "sr") ? "orange.600" : "inherit"}
                  textDecoration={pendingUser === "FI User" && (workflowProcess?.processName === "pr" || workflowProcess?.processName === "sr") ? "underline" : "none"}
                >
                  {pendingUser}
                  {pendingUser === "FI User" && (workflowProcess?.processName === "pr" || workflowProcess?.processName === "sr") && (
                    <Text as="span" fontSize="10px" color="orange.500" fontStyle="italic" ml={1} textDecoration="none">
                      (Click to view)
                    </Text>
                  )}
                </Text>
              </Box>
            </Tooltip>
            {pendingUser !== "Posted" && pendingUser !== "-" && (
              <Tooltip label="Copy" hasArrow>
                <Box
                  cursor="pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    try {
                      navigator.clipboard?.writeText(pendingUser);
                      toastNotify({
                        title: "Copied",
                        message: "Name copied to clipboard",
                        type: "success",
                      });
                    } catch (err) {
                      toastNotify({
                        title: "Failed",
                        message: "Unable to copy text",
                        type: "error",
                      });
                    }
                  }}
                >
                  <CopyIcon color="gray.500" />
                </Box>
              </Tooltip>
            )}
          </Flex>
        </Td>

        {tableObject?.columnName?.map((column: any, columnIndex: any) => {
          if (!column.isActive) return null;
          let content = null;
          if(column.key==="created_At"){
            return null
          }
          if(name === "Pending Approval" && column.key==="sapDocumentNumber"){
            return null
          }
          if (column.key === "Status" && (workflowProcess?.processType === "NonPo" || workflowProcess?.processType === "nonpo")) {
            return null
          }
          if ((column.key === "Currency" || column.key === "currency") && (workflowProcess?.processName === "foreign")) {
            content = (
              <Td>{getTextValue(item, "Currency")}</Td>
            )
          } else if (column.key === "comments") {
            return null
          } else if (
            column.key === "created_At" ||
            column.key === "updated_At"
          ) {
            content = (
              <Td
                key={columnIndex}
                whiteSpace={column.rowNoWrap === true ? "nowrap" : "unset"}
              >
                {formatDateTime(item[column.key], DDMMYYYY_FORMAT, true)}
              </Td>
            );
          } else if (column.isFile) {
            content = (
              <Td
                key={columnIndex}
                color="blue.400"
                textDecoration="underline"
                fontWeight="500"
                onClick={(e: any) => {
                  e.stopPropagation();
                  if (item[column.key]?.length) {
                    if (column.fileView) {
                      setOpenTableModel({
                        type: "file",
                        open: true,
                        file: item[column.key],
                      });
                    } else {
                      toastNotify({
                        title: "Access Error",
                        message: "Sorry, there was an issue accessing the file",
                        type: "error",
                      });
                    }
                  }
                }}
              >
                {Array.isArray(item[column.key]) ? (
                  item[column.key]?.length ? (
                    <Tooltip
                      hasArrow
                      textAlign="center"
                      label={item[column.key][0]?.filename}
                    >
                      {item[column.key][0]?.filename.substring(0, 10) + "..."}
                    </Tooltip>
                  ) : (
                    "--"
                  )
                ) : (
                  JSON.stringify(item[column.key])
                )}
              </Td>
            );
          } else {
            const rawValue = item?.originalValues?.[column.key] ?? "";

            const tooltipValue =
              column.tooltipLabel ??
              (typeof rawValue === "string"
                ? rawValue
                : rawValue !== ""
                  ? JSON.stringify(rawValue)
                  : "");

            const displayValue = getTextValue(item, column.key) ?? "";
            content = (
              <Td key={columnIndex} isNumeric={column.rowType === "amount"}>
                <Flex align="center" gap={2}>
                  {column.truncatedActive ? (
                    <Tooltip hasArrow label={displayValue}>
                      <Text
                        isTruncated
                        w="7rem"
                        textAlign={
                          column.rowType === "number"
                            ? "center"
                            : column.rowType === "amount"
                              ? "right"
                              : "left"
                        }
                      >
                        {activePage === "Approved" ? (column.key === "postingMessage" ? extractDocumentNumber(displayValue) : displayValue || "—") : displayValue || "—"}
                      </Text>
                    </Tooltip>
                  ) : (
                    <Text
                      textAlign={
                        column.rowType === "number"
                          ? "center"
                          : column.rowType === "amount"
                            ? "right"
                            : "left"
                      }
                      whiteSpace={
                        column.rowNoWrap === true ? "nowrap" : "unset"
                      }
                    >
                      {displayValue || "—"}
                    </Text>
                  )}

                  {[
                    "Invoice_Number",
                    "postingMessage",
                    "sapDocumentNumber",
                    "documentId",
                  ].includes(column.key) &&
                    Boolean(displayValue) && (
                      <Tooltip label="Copy" hasArrow>
                        <Box
                          cursor="pointer"
                          onClick={(e) => {
                            e.stopPropagation();

                            try {
                              const valueToCopy: any = column.key === "postingMessage" ? (extractDocumentNumber(displayValue) || displayValue) : displayValue;
                              navigator.clipboard?.writeText(valueToCopy);
                              toastNotify({
                                title: "Copied",
                                message: "Text copied to clipboard",
                                type: "success",
                              });
                            } catch (err) {
                              toastNotify({
                                title: "Failed",
                                message: "Unable to copy text",
                                type: "error",
                              });
                            }
                          }}
                        >
                          <CopyIcon color="gray.500" />
                        </Box>
                      </Tooltip>
                    )}
                </Flex>
              </Td>
            );

            // content = (
            //   <Td key={columnIndex} isNumeric={column.rowType === "amount"}>
            //     <Flex>
            //     {column.truncatedActive ? (
            //       <Tooltip
            //         hasArrow
            //         label={
            //           column.tooltipLabel
            //             ? column.tooltipLabel
            //             : typeof item.originalValues[column.key] === "string"
            //             ? item.originalValues[column.key]
            //             : JSON.stringify(item.originalValues[column.key])
            //         }
            //       >
            //         <Text
            //           isTruncated
            //           w="7rem"
            //           textAlign={
            //             column.rowType === "number"
            //               ? "center"
            //               : column.rowType === "amount"
            //               ? "right"
            //               : "left"
            //           }
            //         >
            //           {getTextValue(item, column.key)}
            //         </Text>
            //       </Tooltip>
            //     ) : (
            //       <Text
            //         textAlign={
            //           column.rowType === "number"
            //             ? "center"
            //             : column.rowType === "amount"
            //             ? "right"
            //             : "left"
            //         }
            //         whiteSpace={column.rowNoWrap === true ? "nowrap" : "unset"}
            //       >
            //         {getTextValue(item, column.key)}
            //       </Text>
            //     )}
            //     {['Invoice_Number','postingMessage','sapDocumentNumber'].includes(column.key) && <Tooltip label="Copy" hasArrow arrowSize={8}>
            //       <Box
            //         cursor="pointer"
            //         onClick={(e) => {
            //           e.stopPropagation();
            //           navigator.clipboard.writeText(
            //             getTextValue(item, column.key)
            //           );
            //           toastNotify({
            //             title: "Copied",
            //             message: "Text copied to clipboard",
            //             type: "success",
            //           });
            //         }}
            //       >
            //         <CopyIcon color="gray.500" />
            //       </Box>
            //     </Tooltip>}
            //     </Flex>
            //   </Td>
            // );
          }
          return content;
        })}
        {actionButton && (
          <Td>
            <Flex alignItems="center" justifyContent="start">
              {tableObject?.action?.view && (
                <Tooltip label="View" hasArrow arrowSize={15}>
                  <Flex
                    alignItems="center"
                    cursor="pointer"
                    color="green.500"
                    _hover={{ color: "green.600" }}
                  >
                    <Box mr=".5rem" fontSize="1.4rem">
                      <AiFillEye />
                    </Box>
                  </Flex>
                </Tooltip>
              )}
              {tableObject?.action?.edit && (
                <Tooltip label="Edit" hasArrow arrowSize={15}>
                  <Flex
                    alignItems="center"
                    cursor="pointer"
                    mx="1rem"
                    color="green.500"
                    _hover={{ color: "green.600" }}
                  >
                    <Box mr=".5rem">
                      <FaEdit />
                    </Box>
                  </Flex>
                </Tooltip>
              )}
              {tableObject?.action?.delete &&
                accountDetails?.level === "admin" &&
                name === "Pending Approval" && (
                  <Tooltip label="Delete" hasArrow arrowSize={15}>
                    <Flex
                      alignItems="center"
                      cursor="pointer"
                      color="red.500"
                      _hover={{ color: "red.600" }}
                    >
                      <Box
                        mr=".5rem"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (!deleteLoading)
                            setOpenDeleteModal({
                              ...openDeleteModal,
                              data: item,
                              open: true,
                            });
                        }}
                      >
                        <IconButton aria-label="delete" size="sm">
                          <RiDeleteBin5Line color="red" />
                        </IconButton>
                      </Box>
                    </Flex>
                  </Tooltip>
                )}
            </Flex>
          </Td>
        )}
        {/* Actions moved to the right sticky column */}
      </React.Fragment>
    );
  };

  const handleDropdownChange = (value: any, label: string) => {
    setSelectedOptions((prev: any) => ({ ...prev, [label]: value }));
  };

  const handleSearchChange = (value: string) => {
    setSearch(value);
  };

  const handleApply = () => {
    handleGet();
  };

  const resetFilters = () => {
    setSearchFilters([]);
    setSelectedOptions({});
    setSearch("");
    setSortDirection({});
    resetDates(); // This resets global dates
    handleGet(undefined, undefined, true);
  };

  const handleCloseApprovalModal = () => {
    setSelectedRows([]);
    setIsOpen({ isOpen: false, data: null, type: "isFile" });
  };

  const handleOpenWordModal = () => {
    setIsOpen({ isOpen: true, data: null, type: "word" });
    setWordType("create");
  };

  function checkLastRecord(history: any) {
    if (history.length === 0) return "notUpload";
    const lastRecord = history[history.length - 1];
    const isReupload =
      lastRecord.level === "level-1" && lastRecord.status === "approved";
    return isReupload ? "isReupload" : "notUpload";
  }

  return Object.keys(tableObject).length === 0 ? (
    <Box>
      <Text textAlign="center" color="red" mt={5}>
        {" "}
        No table are selected{" "}
      </Text>
    </Box>
  ) : (
    <Box
      boxShadow="rgb(0 0 0 / 20%) 0px 0px 11px"
      bg="white"
      p={{ base: "1rem", md: "1.125rem 1.375rem" }}
      rounded={8}
    >
      <Grid
        templateColumns={"1fr auto"}
        alignItems="center"
        justifyContent="space-between"
        gap="0.5rem"
      >
        {workFlowData?.processName === "foreign" && name === "Pending Approval" ? (
          <Button
            w="180px"
            colorScheme="green"
            size="md"
            borderRadius="md"
            boxShadow="sm"
            display="none"
            // display={accountDetails?.level === "level-1" ? undefined : 'none'}
            onClick={() =>
              setSingleDocumentUplaod({
                open: true,
                type: "foreign",
                data: null,
                file: null,
              })
            }
            _hover={{ boxShadow: "md", transform: "translateY(-1px)" }}
          >
            Add Document
          </Button>
        ) : (
          <Box>
            {tableObject?.header?.label && tableObject?.header?.isActive && (
              <Heading
                fontSize={{
                  base: "1.115rem",
                  lg: "1.6rem",
                }}
                color="teal.300"
                display={{ base: "none", md: accountDetails &&
              accountDetails?.level === "level-1" &&
              workFlowData?.processName === "crm" &&
              type === "pending" ? "none" : "block" }}
              >
                {" "}
                {accountDetails?.level === "level-1" &&
                  accountDetails?.role === "uploader"
                  ? null
                  : tableObject?.header?.label}
              </Heading>
            )}
            {accountDetails &&
              accountDetails?.level === "level-1" &&
              accountDetails?.role === "uploader" &&
              type === "pending" && (
                <Flex gap="1rem">
                  <Button
                    bg="teal.300"
                    color="white"
                    _hover={{ bg: "teal.400" }}
                    onClick={() => handleOpenUploadModal("upload")}
                  >
                    {isBreakpoint ? <FaFileUpload /> : "Upload Document"}
                  </Button>
                </Flex>
              )}
          </Box>
        )}
        <Flex gap="0.5rem" alignItems="center" justifyContent="end">
          {workFlowData?.processName === "foreign" && (
            <Popover placement="bottom-start">
              {({ isOpen, onClose }: any) => (
                <>
                  <PopoverTrigger>
                    <Button
                      size="sm"
                      width="320px"
                      bg="white"
                      borderColor="gray.200"
                      borderWidth="1px"
                      borderRadius="md"
                      justifyContent="space-between"
                      rightIcon={<ChevronDownIcon />}
                      px={3}
                      height={'40px'}
                      fontSize="sm"
                      fontWeight="400"
                      // width="220px"
                      color={selectedInitiator ? "black" : "gray.500"}
                    >
                      {selectedInitiator
                        ? foreignWorkflows.find((wf) => wf.level1_user_id === selectedInitiator)?.level1_username ||
                        foreignWorkflows.find((wf) => wf.level1_user_id === selectedInitiator)?.workFlowName
                        : "Select Initiator"}
                    </Button>
                  </PopoverTrigger>
                  <PopoverContent width="320px" boxShadow="lg" borderRadius="md" _focus={{ outline: "none" }}>
                    <PopoverBody p={2}>
                      <Input
                        placeholder="Search initiator..."
                        size="sm"
                        mb={2}
                        value={initiatorSearchTerm}
                        onChange={(e: any) => setInitiatorSearchTerm(e.target.value)}
                        autoFocus
                      />
                      <Box maxH="200px" overflowY="auto">
                        <Box
                          p={2}
                          cursor="pointer"
                          _hover={{ bg: "teal.50" }}
                          onClick={() => {
                            setSelectedInitiator(null);
                            setInitiatorSearchTerm("");
                            onClose();
                          }}
                          fontSize="sm"
                          fontWeight={!selectedInitiator ? "bold" : "normal"}
                          color={!selectedInitiator ? "teal.500" : "black"}
                        >
                          All Initiators
                        </Box>
                        {filteredInitiators.map((wf) => (
                          <Box
                            key={wf._id}
                            p={2}
                            cursor="pointer"
                            _hover={{ bg: "teal.50" }}
                            onClick={() => {
                              setSelectedInitiator(wf.level1_user_id);
                              setInitiatorSearchTerm("");
                              onClose();
                            }}
                            fontSize="sm"
                            fontWeight={selectedInitiator === wf.level1_user_id ? "bold" : "normal"}
                            color={selectedInitiator === wf.level1_user_id ? "teal.500" : "black"}
                          >
                            {wf.level1_username || wf.workFlowName}
                          </Box>
                        ))}
                        {filteredInitiators.length === 0 && (
                          <Text p={2} fontSize="sm" color="gray.500" textAlign="center">
                            No initiators found
                          </Text>
                        )}
                      </Box>
                    </PopoverBody>
                  </PopoverContent>
                </>
              )}
            </Popover>
          )}

          <Box
            display={{ base: "none", lg: "flex" }}
            gap="0.5rem"
            justifyContent="space-between"
          >
            {accountDetails &&
              accountDetails?.level === "level-1" &&
              workFlowData?.processName === "crm" &&
              accountDetails?.crmInitiatorDocument === true &&
              type === "pending" && (
                <>
                  <Menu>
                    <MenuButton
                      as={Button}
                      leftIcon={<FaFileExcel />}
                      rightIcon={<ChevronDownIcon />}
                      colorScheme="teal"
                      variant="outline"
                      height="40px"
                      _hover={{ bg: "teal.50" }}
                    >
                      Templates
                    </MenuButton>
                    <MenuList zIndex={10}>
                      <MenuItem
                        icon={<FaFileExcel color="green" />}
                        onClick={() => {
                          const link = document.createElement("a");
                          link.href = "/CrmTemplate.xlsx";
                          link.download = "CrmTemplate.xlsx";
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                        }}
                      >
                        CRM Template
                      </MenuItem>
                      <MenuItem
                        icon={<FaFileExcel color="blue" />}
                        onClick={() => {
                          const link = document.createElement("a");
                          link.href = "/CRM_60_Days_Declaration_format.xlsx";
                          link.download = "CRM_60_Days_Declaration_format.xlsx";
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                        }}
                      >
                        Declaration Template
                      </MenuItem>
                    </MenuList>
                  </Menu>
                  <Input
                    type="file"
                    accept=".xlsx, .xls"
                    display="none"
                    ref={fileInputRef}
                    onChange={handleExcelImport}
                  />
                  <Button
                    leftIcon={<FaFileExcel />}
                    colorScheme="green"
                    variant="outline"
                    onClick={() => fileInputRef.current?.click()}
                    isLoading={loading}
                    height="40px"
                  >
                    Bulk Excel Import
                  </Button>
                  <Input
                    type="file"
                    accept=".zip,application/zip,application/x-zip-compressed"
                    display="none"
                    ref={zipFileInputRef}
                    onChange={handleZipImport}
                  />
                  <Button
                    leftIcon={<FaFileUpload />}
                    colorScheme="blue"
                    variant="outline"
                    onClick={() => zipFileInputRef.current?.click()}
                    isLoading={loading}
                    height="40px"
                  >
                    Bulk ZIP Import
                  </Button>
                  <Button
                    colorScheme="green"
                    boxShadow="sm"
                    onClick={() =>
                      setSingleDocumentUplaod({
                        open: true,
                        type: "crm",
                        data: null,
                        file: null,
                      })
                    }
                    _hover={{ boxShadow: "md", transform: "translateY(-1px)" }}
                    height="40px"
                  >
                    Add Document
                  </Button>
                </>
              )}
            {tableObject?.searchActive && (
              <SearchBox
                onSearch={() => { }}
                setValue={setSearch}
                value={search}
              />
            )}
            {tableObject?.dateActive &&
              (workFlowData?.dateFilter?.rangePicker ? (
                <CustomDateRangePicker
                  onStartDateChange={setStartDate}
                  onEndDateChange={setEndDate}
                  dateFrom={startDate}
                  dateTo={endDate}
                  months={2}
                />
              ) : (
                <>
                  <Flex>
                    <Datepicker
                      label="From"
                      date={startDate}
                      onDateChange={setStartDate}
                    />
                  </Flex>
                  <Flex flexDirection={"row"}>
                    <Datepicker
                      label="To"
                      date={endDate}
                      onDateChange={setEndDate}
                    />
                  </Flex>
                </>
              ))}
          </Box>
          <DownloadExcelComponent selectedLevel={selectedLevel} type={type} />
          {tableObject?.dateActive && (
            <Box display={{ base: "none", lg: "block" }}>
              <Tooltip hasArrow textAlign={"center"} label="Search">
                <Button
                  bg="teal.300"
                  color="white"
                  w={{ base: "auto", lg: "3rem" }}
                  _hover={{ bg: "teal.400" }}
                  onClick={() => handleGet()}
                >
                  <SearchIcon />
                </Button>
              </Tooltip>
            </Box>
          )}
          <Box>
            <Tooltip hasArrow textAlign={"center"} label="Reset">
              <Button
                border="2px solid"
                borderColor="teal.300"
                bg="white"
                color="teal.400"
                _hover={{ bg: "teal.300", color: "white" }}
                onClick={resetFilters}
              >
                <HiOutlineRefresh fontSize="1.2rem" />
              </Button>
            </Tooltip>
          </Box>
          {tableObject?.filterActive && (
            <>
              <Box
                display={{ base: "none", md: "block" }}
                w={{ base: "auto", lg: "3rem" }}
              >
                <MultiDropdown
                  selectedOptions={selectedOptions}
                  onDropdownChange={handleDropdownChange}
                  dropdowns={transformedOptions}
                  onApply={handleApply}
                  searchValue={search}
                  onSearchChange={handleSearchChange}
                  resetFilters={resetFilters}
                  dateFrom={startDate}
                  dateTo={endDate}
                  setFromDate={setStartDate}
                  setToDate={setEndDate}
                  isTable={true}
                  handleGet={handleGet}
                  tableObject={tableObject}
                />
              </Box>
              <Box
                position="fixed"
                top="15rem"
                right="1rem"
                display={{ base: "block", md: "none" }}
                w="3rem"
                zIndex={10}
              >
                <MultiDropdown
                  selectedOptions={selectedOptions}
                  onDropdownChange={handleDropdownChange}
                  dropdowns={transformedOptions}
                  onApply={handleApply}
                  searchValue={search}
                  onSearchChange={handleSearchChange}
                  resetFilters={resetFilters}
                  dateFrom={startDate}
                  dateTo={endDate}
                  setFromDate={setStartDate}
                  setToDate={setEndDate}
                  isTable={true}
                  handleGet={handleGet}
                  tableObject={tableObject}
                />
              </Box>
            </>
          )}
          {accountDetails &&
            accountDetails?.level === "level-1" &&
            workFlowData &&
            workFlowData?.fileViewer?.approvalModalOption === "isWord" &&
            type === "pending" && (
              <Button
                bg="teal.300"
                color="white"
                _hover={{ bg: "teal.400" }}
                onClick={handleOpenWordModal}
              >
                <Box display={{ base: "none", md: "block" }}>
                  <Text>Add Word</Text>
                </Box>
                <Box display={{ base: "block", md: "none" }}>
                  <FaPlus />
                </Box>
              </Button>
            )}

          {activePage === "Pending Approval" &&
            accountDetails.role === "approver" &&
            (workFlowData?.bulkApproveApproval ||
              workFlowData?.bulkRejectApproval) && (
              <Flex gap="0.5rem" justifyContent="end">
                {activePage === "Pending Approval" &&
                  accountDetails.role === "approver" &&
                  workFlowData?.bulkApproveApproval && (
                    <Button
                      fontSize="sm"
                      bg="green.400"
                      color="white"
                      _hover={{ bg: "green.500" }}
                      isDisabled={
                        selectedRows.length ? false : true || submitLoader
                      }
                      onClick={() =>
                        setCommentModel({
                          open: true,
                          selectedStatus: "approved",
                          comment: "",
                          isMulti: true,
                        })
                      }
                    >
                      Approve
                    </Button>
                  )}
                {activePage === "Pending Approval" &&
                  accountDetails.role === "approver" &&
                  workFlowData?.bulkRejectApproval && (
                    <Button
                      fontSize="sm"
                      isDisabled={
                        selectedRows.length ? false : true || submitLoader
                      }
                      colorScheme="red"
                      onClick={() =>
                        setCommentModel({
                          open: true,
                          selectedStatus: "rejected",
                          comment: "",
                          isMulti: true,
                        })
                      }
                    >
                      Reject
                    </Button>
                  )}

              </Flex>
            )}
        </Flex>
      </Grid>

      <Box
        position="relative"
        overflow="auto hidden"
        className="customScrollBar"
      >
        <Table
          variant={activePage === "Pending Approval" ? "simple" : "striped"}
          mt="1rem"
          size="sm"
          sx={{ "td": { fontSize: "12px", py: "6px" }, "th": { fontSize: "11px", py: "6px" } }}
        >
          <Thead>
            <Tr>
              {activePage === "Pending Approval" &&
                (workFlowData?.bulkApproveApproval ||
                  workFlowData?.bulkRejectApproval) &&
                accountDetails.role === "approver" && (
                  <Th w={10}>
                    <Checkbox
                      colorScheme="teal"
                      isChecked={data.length === selectedRows.length}
                      isIndeterminate={
                        selectedRows.length > 0 &&
                        data.length !== selectedRows.length
                      }
                      onChange={(e: any) => {
                        if (e.target.checked) {
                          setSelectedRows(data);
                        } else {
                          setSelectedRows([]);
                        }
                      }}
                    />
                  </Th>
                )}
              {generateHeaders()}
              {name === "Approved" && !['pr', 'sr','foreign'].includes(workflowProcess.processName) && <Th>SapUtrNumber</Th>}
              {name === "Approved" && !['pr', 'sr','foreign'].includes(workflowProcess.processName) && <Th>SapUtrDate</Th>}
              {name === "Approved" && workflowProcess?.processName ==="foreign" && <Th minW={120}>Payment UTR No.</Th>}
              <Th
                position="sticky"
                right={0}
                zIndex={2}
                textAlign="center"
                boxShadow="-2px 0 5px rgba(0,0,0,0.05)"
              >
                Action
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            <TableLoader
              loader={loading}
              show={data.length}
              columns={
                actionButton && workFlowData?.fileViewer?.showApprHistory
                  ? tableObject?.columnName?.length + 2
                  : actionButton
                    ? tableObject?.columnName?.length + 1
                    : workFlowData?.fileViewer?.showApprHistory
                      ? tableObject?.columnName?.length + 1
                      : tableObject?.columnName?.length
              }
            >
              {sortedData.map((item: any, index) => (
                <React.Fragment key={index}>
                  <Tr
                    fontSize="12px"
                    onClick={(e: any) => {
                      if (workFlowData?.fileViewer?.show) {
                        let appr =
                          getApprovalStatus(item.approval) === "rejected"
                            ? "approvalHistory"
                            : "fileModal";
                        handleOpenModal({
                          file: item?.file?.[0],
                          value: item.values,
                          id: item?._id,
                          level: accountDetails.level,
                          approvalData: item?.approval,
                          documentId: item?.documentId,
                          tagType: item?.tags?.extraction?.type,
                          item: item,
                          type:
                            workFlowData?.fileViewer?.approvalModalOption ===
                              "isFile"
                              ? "file"
                              : workFlowData?.fileViewer
                                ?.approvalModalOption === "isTable"
                                ? "table"
                                : workFlowData?.fileViewer
                                  ?.approvalModalOption === "isCurebay"
                                  ? "curebay"
                                  : workFlowData?.fileViewer
                                    ?.approvalModalOption === "schema"
                                    ? "schema"
                                    : workFlowData?.fileViewer
                                      ?.approvalModalOption ===
                                      "pdfApproval"
                                      ? "pdfApproval"
                                      : workFlowData?.fileViewer
                                        ?.approvalModalOption === "mdm"
                                        ? "mdm"
                                        : workFlowData?.fileViewer
                                          ?.approvalModalOption === "fields"
                                          ? "fields"
                                          : "word",
                          modalType: appr,
                        });
                      }
                    }}
                    cursor="pointer"
                    key={index}
                    bg={
                      getUtilityDocument(item) ? "yellow.100" :
                        activePage === "Pending Approval"
                          ? getStatus(item.approval) === "rejected"
                            ? "red.100"
                            : getStatus(item.approval) === "approved"
                              ? "green.100"
                              : undefined
                          : undefined
                    }
                  >
                    {activePage === "Pending Approval" &&
                      (workFlowData?.bulkApproveApproval ||
                        workFlowData?.bulkRejectApproval) &&
                      accountDetails.role === "approver" && (
                        <Td onClick={(e: any) => e.stopPropagation()}>
                          <Flex alignItems="center">
                            <Checkbox
                              variant="outline"
                              borderColor="teal"
                              colorScheme="teal"
                              isChecked={selectedRows.some(
                                (it: any) => it._id === item._id,
                              )}
                              onMouseDown={(e: any) => {
                                e.stopPropagation();
                                e.preventDefault();
                              }}
                              onChange={(e: any) => {
                                handleSelectedBoxChange(item);
                              }}
                            />
                          </Flex>
                        </Td>
                      )}
                    {generateRows(item)}
  {name === "Approved" && !['pr', 'sr','foreign'].includes(workflowProcess.processName) && <Td>
    {item?.sapUtrNumberDetail
      ? (typeof item.sapUtrNumberDetail === "string" ||
         typeof item.sapUtrNumberDetail === "number")
        ? item.sapUtrNumberDetail
        : JSON.stringify(item.sapUtrNumberDetail)
      : "---"}
  </Td>}
  {name === "Approved" && !['pr', 'sr','foreign'].includes(workflowProcess.processName) && <Td>
    {item?.sapUtrNumberDate ? item.sapUtrNumberDate : "---"}
  </Td>}
  {
    name === "Approved" && workflowProcess?.processName ==="foreign" && <Td>
       {item?.paymentDetail?.paymentUtrNumber || item?.paymentDetails?.paymentUtrNumber || item?.paymentUtrNumber || "--"}
    </Td>
  }
                    <Td
                      position="sticky"
                      right={0}
                      zIndex={1}
                      bg={
                        getUtilityDocument(item) ? "yellow.100" :
                          activePage === "Pending Approval"
                            ? getStatus(item.approval) === "rejected"
                              ? "red.100"
                              : getStatus(item.approval) === "approved"
                                ? "green.100"
                                : "white"
                            : "white"
                      }
                      boxShadow="-2px 0 5px rgba(0,0,0,0.05)"
                    >
                      <Flex alignItems="center" justifyContent="center" gap={3}>
                        {workFlowData?.fileViewer?.showApprHistory && (
                          <Flex gap={3} alignItems="center">
                            <Tooltip label="View Approval History" hasArrow arrowSize={15}>
                              <Box
                                onClick={(e: any) => {
                                  e.stopPropagation();
                                  if (workFlowData?.fileViewer?.show) {
                                    let appr =
                                      getApprovalStatus(item.approval) === "rejected"
                                        ? "approvalHistory"
                                        : "fileModal";
                                    handleOpenModal({
                                      file: item?.file?.[0],
                                      value: item.values,
                                      id: item?._id,
                                      level: accountDetails.level,
                                      approvalData: item?.approval,
                                      documentId: item?.documentId,
                                      tagType: item?.tags?.extraction?.type,
                                      item: item,
                                      type: "pdfApproval",
                                      modalType: appr,
                                    });
                                  }
                                }}
                                cursor="pointer"
                                color="red.500"
                                _hover={{ color: "red.600" }}
                                w="20px"
                              >
                                <FaHistory size={16} />
                              </Box>
                            </Tooltip>
                            {accountDetails &&
                              accountDetails?.level === "level-1" &&
                              accountDetails?.role === "uploader" &&
                              checkLastRecord(item.approval) === "isReupload" && (
                              <Tooltip label="Re-Upload Document" hasArrow arrowSize={5}>
                                <Button
                                  bg="teal.300"
                                  size="xs"
                                  color="white"
                                  _hover={{ bg: "teal.400" }}
                                  onClick={(e: any) => {
                                    e.stopPropagation();
                                    handleOpenUploadModal("alternative", item?._id);
                                  }}
                                >
                                  <FaFileUpload />
                                </Button>
                              </Tooltip>
                            )}
                          </Flex>
                        )}

                        {true && workflowProcess.processName !== "foreign" && (
                          <Tooltip label="Add additional documents" hasArrow placement="top">
                            <Box
                              onClick={(e) => {
                                e.stopPropagation();
                                setSelectedRows([item]);
                                setAddtionalDocuments({
                                  open: true,
                                  data: item.addtionalDocuments || [],
                                });
                              }}
                              cursor="pointer"
                            >
                              <HiOutlineDocumentAdd size={18} color="#4CAF50" />
                            </Box>
                          </Tooltip>
                        )}

                        {activePage === "Pending Approval" && accountDetails?.level === "level-1" && (
                          <Tooltip label="Assign Doc" hasArrow arrowSize={15}>
                            <Box
                              cursor="pointer"
                              color="red.500"
                              _hover={{ color: "red.600" }}
                              onClick={(e: any) => {
                                e.stopPropagation();
                                setAssignDocument({ open: true, data: item });
                              }}
                            >
                              <MdAssignmentInd size={18} />
                            </Box>
                          </Tooltip>
                        )}

                        {workFlowData?.withdrawalApproval?.includes(name?.toLowerCase()) &&
                         workFlowData.withdrawalLevel.includes(accountDetails.level) && (
                          <Tooltip label="Withdrawal Doc" hasArrow placement="top">
                            <Box
                              onClick={(e: any) => {
                                e.stopPropagation();
                                setWithdrawalDoc({ open: true, data: item });
                              }}
                              cursor="pointer"
                              color="orange.500"
                            >
                              <MdCancel size={18} />
                            </Box>
                          </Tooltip>
                        )}

                        {
                          name === "Approved" && (
                            <Flex gap={2} alignItems="center">
                              {tableObject.action.downloadPDF && accountDetails?.userPermission?.includes("download") && (
                                <Tooltip label="Download PDF" hasArrow placement="top">
                                  <Button
                                    size="xs" color="white" bg="red.400" _hover={{ bg: "red.500" }}
                                    onClick={(e: any) => {
                                      e.stopPropagation();
                                      if (item?.file?.length) { downloadPDF(item?.file?.[0]); }
                                      else { toastNotify({ title: "No file", message: "Something went wrong", type: "error" }); }
                                    }}
                                  >
                                    <FaFilePdf />
                                  </Button>
                                </Tooltip>
                              )}
                              {tableObject.action.downloadExcel && accountDetails?.userPermission?.includes("download") && (
                                <Tooltip label="Download Excel" hasArrow placement="top">
                                  <Button
                                    size="xs" color="white" bg="green.500" _hover={{ bg: "green.600" }}
                                    onClick={(e: any) => {
                                      e.stopPropagation();
                                      if (Array.isArray(item?.values) && item?.values?.length) { downloadExcel(item?.values, "download"); }
                                      else if (!Array.isArray(item?.values) && item?.values?.values) { downloadExcel(item?.values, "download"); }
                                      else toastNotify({ title: "No Data Found", message: "Something went wrong", type: "error" });
                                    }}
                                  >
                                    <FaFileExcel />
                                  </Button>
                                </Tooltip>
                              )}
                              <Tooltip label="Fetch SAP/UTR Number" hasArrow placement="top">
                                <Button
                                  size="xs" color="white" bg="blue.500" _hover={{ bg: "blue.600" }}
                                  onClick={(e: any) => {
                                    e.stopPropagation();
                                    handleFetchSapDocNumber(item);
                                  }}
                                  display="none"
                                >
                                  <HiOutlineRefresh />
                                </Button>
                              </Tooltip>
                            </Flex>
                          )}
                      </Flex>
                    </Td>
                  </Tr>
                </React.Fragment>
              ))}
            </TableLoader>
          </Tbody>
        </Table>
      </Box>

      {singleDocumentUplaod.type === "foreign" &&
        singleDocumentUplaod?.open === true && (
          <ForeignProcess
            isDisabled={isDisabled}
            commentData={comment}
            tagType={tagType}
            documentType={documentType}
            name={name}
            docId={documentID}
            documentId={selectedId}
            selectedRows={selectedRows}
            handleGet={handleGet}
            setSelectedRows={setSelectedRows}
            commentModel={commentModel}
            activePage={activePage}
            setCommentModel={setCommentModel}
            isOpen={singleDocumentUplaod.open}
            file={selectedFile}
            item={singleDocumentUplaod?.data}
            onClose={() => {
              setSingleDocumentUplaod({
                open: false,
                data: null,
                type: "foreign",
                file: null,
              });
              setSelectedFile({});
            }}
          />
        )}


      {singleDocumentUplaod.type === "emerging" &&
        singleDocumentUplaod?.open === true && (
          <EmergingProcess
            isDisabled={isDisabled}
            commentData={comment}
            tagType={tagType}
            documentType={documentType}
            name={name}
            docId={documentID}
            documentId={selectedId}
            selectedRows={selectedRows}
            handleGet={handleGet}
            setSelectedRows={setSelectedRows}
            commentModel={commentModel}
            activePage={activePage}
            setCommentModel={setCommentModel}
            isOpen={singleDocumentUplaod.open}
            file={selectedFile}
            item={singleDocumentUplaod?.data}
            asInitiator={!singleDocumentUplaod?.data}
            onClose={() => {
              setSingleDocumentUplaod({
                open: false,
                data: null,
                type: "foreign",
                file: null,
              });
              setSelectedFile({});
            }}
          />
        )}

      {singleDocumentUplaod.type === "crm" &&
        singleDocumentUplaod?.open === true && (
          <CrmProcess
            isDisabled={isDisabled}
            commentData={comment}
            tagType={tagType}
            documentType={documentType}
            name={name}
            docId={documentID}
            documentId={selectedId}
            selectedRows={selectedRows}
            handleGet={handleGet}
            setSelectedRows={setSelectedRows}
            commentModel={commentModel}
            activePage={activePage}
            setCommentModel={setCommentModel}
            isOpen={singleDocumentUplaod.open}
            file={selectedFile}
            item={singleDocumentUplaod?.data}
            asInitiator={!singleDocumentUplaod?.data}
            onClose={() => {
              setSingleDocumentUplaod({
                open: false,
                data: null,
                type: "foreign",
                file: null,
              });
              setSelectedFile({});
            }}
          />
        )}

      {singleDocumentUplaod.type === "pr" &&
        singleDocumentUplaod?.open === true && (
          <PrProcess
            isDisabled={isDisabled}
            commentData={comment}
            tagType={tagType}
            documentType={documentType}
            name={name}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            commentModel={commentModel}
            setCommentModel={setCommentModel}
            isOpen={singleDocumentUplaod.open}
            file={selectedFile}
            item={singleDocumentUplaod?.data}
            handleGet={handleGet}
            onClose={() => {
              setSingleDocumentUplaod({
                open: false,
                data: null,
                type: "foreign",
                file: null,
              });
              setSelectedFile({});
            }}
          />
        )}

      {singleDocumentUplaod.type === "sr" &&
        singleDocumentUplaod?.open === true && (
          <SrProcess
            isDisabled={isDisabled}
            commentData={comment}
            tagType={tagType}
            documentType={documentType}
            name={name}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            commentModel={commentModel}
            setCommentModel={setCommentModel}
            isOpen={singleDocumentUplaod.open}
            file={selectedFile}
            item={singleDocumentUplaod?.data}
            handleGet={handleGet}
            onClose={() => {
              setSingleDocumentUplaod({
                open: false,
                data: null,
                type: "foreign",
                file: null,
              });
              setSelectedFile({});
            }}
          />
        )}

      {(singleDocumentUplaod.type === "po" || singleDocumentUplaod.type === "Po") &&
        singleDocumentUplaod?.open === true && (
          <POComponent
            file={selectedFile}
            data={singleDocumentUplaod?.data}
            isOpen={singleDocumentUplaod.open}
            handleGet={handleGet}
            name={name}
            onClose={() => {
              setSingleDocumentUplaod({
                open: false,
                data: null,
                type: "foreign",
                file: null,
              });
              setSelectedFile({});
            }}
            onSubmit={async (finalData) => {
               console.log("POComponent final data ready for submission: ", finalData);
               // Handle PO Component submission here (e.g. appRequest update)
            }}
          />
        )}

      {isOpen.isOpen && isOpen.type === "file" && (
        <ViewerModal
          isOpen={isOpen.isOpen}
          onClose={handleCloseModal}
          file={selectedFile}
          values={values}
          showValues={workFlowData?.fileViewer?.showValue}
          id={selectedId}
          level={level}
          getData={handleGet}
          isManual={isManual}
          isDisabled={isDisabled}
          commentData={comment}
          tagType={tagType}
          documentType={documentType}
          name={name}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          commentModel={commentModel}
          setCommentModel={setCommentModel}
          handleGet={handleGet}
        />
      )}
      {isOpen.isOpen && isOpen.type === "curebay" && (
        <CurbayViewerModel
          isOpen={isOpen.isOpen}
          onClose={handleCloseModal}
          file={selectedFile}
          values={values}
          showValues={workFlowData?.fileViewer?.showValue}
          id={selectedId}
          level={level}
          getData={handleGet}
          isManual={isManual}
          isDisabled={isDisabled}
          commentData={comment}
          tagType={tagType}
          documentType={documentType}
          name={name}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          commentModel={commentModel}
          setCommentModel={setCommentModel}
          handleGet={handleGet}
        />
      )}
      {tableObject?.isPaginate?.isActive && (
        <Pagination
          totalPages={totalPages}
          handlePageChange={handlePageChange}
          currentPage={currentPage}
        />
      )}

      {commentModel.isMulti === true && (
        <AddComentModal
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          commentModel={commentModel}
          setCommentModel={setCommentModel}
          handleGet={handleGet}
          view={false}
          handleCloseModal={handleCloseModal}
          editedValues={{}}
          isMulti={true}
        />
      )}
      {openTableModel.open && openTableModel.file && (
        <FileViewerModal
          isOpen={openTableModel.open}
          onClose={() => {
            setOpenTableModel({ open: false, type: "file", file: null });
          }}
          documentId={documentID}
          viewerWidth="70vw"
          file={
            Array.isArray(openTableModel.file)
              ? openTableModel.file.length > 0
                ? openTableModel.file[0]
                : null
              : openTableModel.file
          }
        />
      )}
      {addtionalDocuments.open && (
        <AddtionalDocumentModal
          handleGet={handleGet}
          selectedRows={selectedRows}
          isOpen={addtionalDocuments.open}
          onClose={() => {
            setSelectedRows([]);
            setAddtionalDocuments({ data: [], open: false });
          }}
        />
      )}
      {isOpen.isOpen && isOpen.type === "word" && (
        <WordDocumentViewer
          isOpen={isOpen.isOpen}
          onClose={handleCloseModal}
          file={selectedFile}
          values={values}
          showValues={workFlowData?.fileViewer?.showValue}
          id={selectedId}
          level={level}
          getData={handleGet}
          isManual={isManual}
          isDisabled={isDisabled}
          commentData={comment}
          tagType={tagType}
          documentType={documentType}
          name={name}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          commentModel={commentModel}
          setCommentModel={setCommentModel}
          handleGet={handleGet}
          type={wordType}
          statusType={type}
        />
      )}
      {isOpen.isOpen && isOpen.type === "table" && (
        <TableViewerModel
          isOpen={isOpen.isOpen}
          onClose={handleCloseModal}
          file={selectedFile}
          values={values}
          showValues={workFlowData?.fileViewer?.showValue}
          id={selectedId}
          level={level}
          getData={handleGet}
          isManual={isManual}
          isDisabled={isDisabled}
          commentData={comment}
          tagType={tagType}
          documentType={documentType}
          name={name}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          commentModel={commentModel}
          setCommentModel={setCommentModel}
          handleGet={handleGet}
          tableObject={tableObject}
        />
      )}
      {isOpen.isOpen && isOpen.type === "pdfApproval" && (
        <ApprovalHistoryModal
          isOpen={isOpen.isOpen}
          onClose={handleCloseApprovalModal}
          name={name}
          approvalHistory={approvalData}
          file={selectedFile}
          id={selectedId}
          commentModel={commentModel}
          setCommentModel={setCommentModel}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          handleGet={handleGet}
          docID={documentID}
        />
      )}
      {openFilesModal.open === true &&
        openFilesModal.data &&
        openFilesModal.type === "files_verification" && (
          <FilesModal
            isDisabled={isDisabled}
            commentData={comment}
            tagType={tagType}
            documentType={documentType}
            name={name}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            commentModel={commentModel}
            setCommentModel={setCommentModel}
            file={selectedFile}
            docID={documentID}
            values={values}
            open={openFilesModal.open}
            data={openFilesModal.data}
            getData={handleGet}
            close={() => {
              setOpenFilesModel({
                open: false,
                data: null,
                type: "files_verification",
              });
            }}
          />
        )}
      <UploadDocumentModal
        isOpen={isUploadOpen.open}
        onClose={handleCloseUploadModal}
        type={modalType}
        handleGet={handleGet}
        id={isUploadOpen.id}
      />
      {isOpen.isOpen && isOpen.type === "mdm" && (
        <CurbayMedicineCustomModal
          handleGet={handleGet}
          open={isOpen.isOpen}
          close={() => {
            setSelectedRows([]);
            setIsOpen({ isOpen: false, type: "mdm", data: null });
          }}
          getData={handleGet}
          isDisabled={isDisabled}
          commentData={comment}
          tagType={tagType}
          documentType={documentType}
          name={name}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          commentModel={commentModel}
          setCommentModel={setCommentModel}
          file={selectedFile}
          docID={documentID}
          values={values}
        />
      )}
      {isOpen.isOpen && isOpen.type === "fields" && (
        <FieldsModal
          handleGet={handleGet}
          open={isOpen.isOpen}
          close={() => {
            setSelectedRows([]);
            setIsOpen({ isOpen: false, type: "fields", data: null });
          }}
          getData={handleGet}
          isDisabled={isDisabled}
          commentData={comment}
          tagType={tagType}
          documentType={documentType}
          name={name}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          commentModel={commentModel}
          setCommentModel={setCommentModel}
          file={selectedFile}
          docID={documentID}
          values={values}
        />
      )}
      <MailModal
        fileData={fileData}
        isOpen={isMailOpen.open}
        onClose={handleCloseMail}
        fieldName={fieldName}
        setFieldName={setFieldName}
        transformedData={exportToExcelsss(transformedData)}
        values={isMailOpen.data}
        setFileData={setFileData}
        sendMail={["mail"]}
        setFinalResults={setFinalResults}
      />

      {openSchemaModel.open && openSchemaModel.type === "schema" && (
        <DynamicSchemaModel
          openSchemaModal={openSchemaModel}
          isOpen={openSchemaModel.open}
          data={openSchemaModel.data}
          file={selectedFile}
          onClose={() => {
            setOpenSchemaModel({
              open: false,
              data: null,
              type: "schema",
              initialUpload: false,
              file: null,
            });
            setSelectedRows([]);
          }}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          commentModel={commentModel}
          setCommentModel={setCommentModel}
          handleGet={handleGet}
          name={name}
        />
      )}
      <WithDrawalDocModal
        title={`Document : ${withdrawalDoc?.data?.documentId}`}
        bodyText="This action cannot be undone"
        subTitleText="Please Confirm?"
        onConfirm={() => withDrawalDocuments()}
        isOpen={withdrawalDoc.open}
        onClose={() =>
          setWithdrawalDoc({ data: null, open: false, loading: false })
        }
        loading={withdrawalDoc?.loading}
      />
      <DeleteModal
        title={`Document : ${openDeleteModal?.data?.documentId}`}
        bodyText="This action cannot be undone. Deleting this user will remove all associated permissions."
        subTitleText="Please Confirm?"
        onConfirm={() => deleteDocuments()}
        isOpen={openDeleteModal.open}
        onClose={() => setOpenDeleteModal({ data: null, open: false })}
        loading={deleteLoading}
      />
      <AssignDocumentModal
        isPending={true}
        isOpen={assignDocument.open}
        data={assignDocument?.data}
        close={() => setAssignDocument({ open: false, data: null })}
        getAllData={handleGet}
      />
    </Box>
  );
}